import { getContext, setContext } from 'svelte';
import { type Readable, readonly, type Writable } from 'svelte/store';

const symbol = Symbol('SecuredAreaModalOpenState key from context');

export function getSecuredAreaActions() {
    try {
        let state: Writable<boolean> = getContext(symbol);
        return { open: () => state.set(true), close: () => state.set(false) };
    } catch {
        throw new Error(
            'SecuredAreaModalOpenState must set in context with setSecuredAreaModalOpenState',
        );
    }
}
export function getSecuredAreaModalOpenState(): Readable<boolean> {
    try {
        return readonly(getContext(symbol));
    } catch {
        throw new Error(
            'SecuredAreaModalOpenState must set in context with setSecuredAreaModalOpenState',
        );
    }
}

export function setSecuredAreaModalOpenState(state: Writable<boolean>) {
    setContext(symbol, state);
}
